import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../../../../state/standardLoanStore';
import { isRequiredOnceNoteDated } from '../../../../../../../SetupAndBorrower/Setup/functions/isRequiredOnceNoteDated';

/** Unlike the other amounts, 0 is valid. Locked while "Same as Committed". */
export const BridgeFundedField = () => {
    /** Keeps 0; anything negative or missing is "no value" (same as EditStdLoanModal's setBridgeFunded). */
    const toBridgeFunded = (amount: number | null | undefined) =>
        amount !== null && amount !== undefined && !isNaN(amount) && amount >= 0 ? amount : undefined;

    const value = useStandardLoanStore((state) => state.loan.bridgeFunded);
    const sameAsCommitted = useStandardLoanStore((state) => state.sameAsCommitted);
    const setup = useStandardLoanStore((state) => state.setup);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <MoneyBox
            id='loanBridgeFunded'
            value={value}
            onChange={(amount) => updateLoan({ bridgeFunded: toBridgeFunded(amount) })}
            label='Bridge Funded'
            required={isRequiredOnceNoteDated(setup)}
            disabled={sameAsCommitted}
            displayChange={true}
            min={0}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
